import {Observable} from 'rxjs';
import { Injectable } from "@angular/core";


import {Group, Rule, Source} from "app/models/group_ref.model";
import { AuthService } from '../../auth.service';
import { DataProvider2 } from "../../provider/data2.provider";

@Injectable()
export class GroupRefService {
	constructor(
		public authService: AuthService,
		public dp: DataProvider2,
	) {
		
	}
	
	getStatus(): any {
		return this.dp.get('/group_ref/status');
	}
	
	getGroups(): Observable<Group[]> {
		return this.dp.get('/group_ref/groups');
	}
	
	getSources(groupId: number): Observable<Source[]> {
		return this.dp.get('/group_ref/sources', { groupId });
	}
	
	getRules(groupId: number, sourceId: number): Observable<Rule[]> {
		return this.dp.get('/group_ref/rules', { groupId, sourceId });
	}
	
	deleteGroup(id: number): any {
		return this.dp.delete(`/group_ref/groups/${id}`);
	}
	
	deleteSource(id: number): any {
		return this.dp.delete(`/group_ref/sources/${id}`);
	}
	
	addGroup(name: string): any {
		return this.dp.post('/group_ref/groups', { name });
	}
	
	renameGroup(id: number, name: string): any {
		return this.dp.put(`/group_ref/groups/${id}`, { name });
	}
	
	sortGroups(priorities: Group[]): any {
		return this.dp.post('/group_ref/groups', { priorities });
	}
	
	sortSources(priorities: Source[]): any {
		return this.dp.post('/group_ref/sources', { priorities });
	}
	
	editSource(source: Source): any {
		return this.dp.put(
			`/group_ref/sources/${source.id}`,
			{
				id: source.id,
				groupId: source.groupId,
				name: source.name,
				rules: source.rules
			}
		);
	}
	
	saveSource(source: Source): any {
		return this.dp.post(
			'/group_ref/sources',
			{
				groupId: source.groupId,
				name: source.name,
				rules: source.rules
			}
		);
	}
	
	rebuild() {
		return this.dp.get('/group_ref/rebuild');
	}
	
	canRunRebuild() {
		return this.authService.isAdmin;
	}
}
